import axios from 'axios'
import { AxiosInterceptor } from '../Config/AxiosInterceptor'

AxiosInterceptor()

const uploadDocumentService = {
  upload(
    documentName: string | undefined,
    entityUuid: string | undefined,
    formData: FormData,
    fileName?: string,
    config?: any,
  ) {
    const params = new URLSearchParams()
    params.append('fileUploadCategory', documentName as string)
    params.append('entityId', entityUuid as string)

    if (fileName) {
      params.append('fileName', fileName)
    }

    return axios.put(`/v2/upload?${params.toString()}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...(config?.headers || {}),
      },
      ...config,
    })
  },

  policies(type: string, formData: FormData, fileName?: string) {
    const params = new URLSearchParams()
    params.append('type', type)

    if (fileName) {
      params.append('fileName', fileName)
    }

    return axios.post(`/admin/policy/create?${params.toString()}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  adminGetAllPolicies: async () => {
    return await axios.get('/admin/policy/all?latest=true')
  },

  adminDeletePolicy: async (policyType: string) => {
    return await axios.delete(`/admin/policy/delete?policyType=${policyType}`)
  },

  userGetAllPolicies: async () => {
    return await axios.get('/employee/policy')
  },
}

export default uploadDocumentService
